<template lang="pug">
  .partners-container.container.has-text-centered
    h2 {{ gettext('Company profile') }}
    .personal-profile-grid
      .main
        .field.is-horizontal
          label.label.name {{ gettext('Name of company') }}*
          .field-body
            input.input(
            name="company-name"
            :placeholder="gettext('Only latin letters')"
            :disabled="!allowEdit"
            @blur="validateData('company_name')"
            v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support') : errors.required, show: tooltip.company_name}"
            @input="form.company_name = validateLatinCharacter($event)"
            :class="{'is-danger': $v.form.company_name.$error }"
            v-model="form.company_name")
            label.label.edit
              .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('company_name')")
        .field.is-horizontal
          label.label.name {{ gettext('Country') }}*
          .field-body
            ajax-dropdown.wide(
            v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support') : errors.required, show: tooltip.country}"
            v-model="form.country"
            @selected="form.region.id ? form.region = '': false"
            :labelText="gettext('Choose the country')"
            :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_employer_profile']}}",
            :itemName ="'name'"
            :disabled="true"
            )
            label.label.edit
              .mdi.mdi-comment-question-outline.icon-edit(@click="toogleInfoshow('country')")
        .field.is-horizontal(@click="validateData('region')")
          label.label.name {{ gettext('Region') }}*
          .field-body
            ajax-dropdown.wide(
            v-if="form.country.iso2"
            v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support') : errors.required, show: tooltip.region}"
            v-model="form.region"
            :disabled="!allowEdit"
            :labelText="gettext('Choose the region')"
            :class="{'is-danger': $v.form.region.$error }"
            :action="{method: 'receiveRegions', params: {lang: getLanguage, country: form.country.iso2}}",
            :itemName ="'name'"
            )
            label.label.edit
              .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('region')")
        .field.is-horizontal
          label.label.name {{ gettext('Registration number') }}*
          .field-body
            input.input(
            name="registration-number"
            type="text"
            @blur="validateData('company_reg_number')"
            :disabled="!allowEdit"
            :class="{'is-danger': $v.form.company_reg_number.$error }"
            v-tooltip="{content: !allowEdit ? gettext('These data can only be changed by contacting customer support') : errors.required, show: tooltip.company_reg_number}"
            v-model="form.company_reg_number")
            label.label.edit
              .mdi.mdi-comment-question-outline.icon-edit(v-if="!allowEdit" @click="toogleInfoshow('company_reg_number')")
        .field.is-horizontal
          label.label.name {{ gettext('Contact person') }}*
          .field-body
            input.input(
            name="contact-person"
            v-tooltip="{content: errors.required, show: tooltip.contact_person}"
            @blur="validateData('contact_person')"
            @input="form.contact_person = validateLatinCharacter($event)"
            :placeholder="gettext('Only latin letters')"
            :class="{'is-danger': $v.form.contact_person.$error }"
            v-model="form.contact_person")
            label.label.edit

        .field.is-horizontal
          label.label.name {{ gettext('Phone number') }}*
          .field-body
            v-phone-input(
            name="phone"
            v-tooltip="{content: errors.server.contact_phone || errors.required, show: tooltip.contact_phone}"
            @blur="validateData('contact_phone')"
            :class="{'is-danger': $v.form.contact_phone.$error }"
            type="text"
            @onInput="form.contact_phone = $event.number"
            :phone="form.contact_phone"
            @valid="phoneValid = $event"
            )
            label.label.edit

        .field.is-horizontal
          label.label.name {{ gettext('Website') }}
          .field-body
            input.input(
            name="site"
            :class="{'is-danger': (errors.server.contact_website && !form.contact_website)}"
            v-tooltip="{content: errors.server.contact_website, show: (errors.server.contact_website && !form.contact_website)}"
            @input="form.contact_website = validateLatinCharacter($event)"
            :placeholder="gettext('Only latin letters')"
            v-model="form.contact_website")
            label.label.edit

        .field.is-horizontal
          label.label.name {{ gettext('About') }}
          .field-body
            textarea.textarea(
            name="about"
            :placeholder="gettext('Only latin letters')"
            @input="form.company_about = validateLatinCharacter($event)"
            v-model="form.company_about")
            label.label.edit

        .field.is-horizontal
          label.label.name
          .field-body
            button.main-btn.col-white.bg-red.btn-big(@click="updateProfile" :disabled="imageLoading || !formIsValid || cropped") {{gettext('Save') }}
            label.label.edit

        .field.is-horizontal.linned-bottom
          label.label.name
          .field-body
            label.label.edit
        .field.is-horizontal(v-if="false")
          label.label.name.font.full {{ gettext('Social connections') }}
          .field-body
            label.label.edit
        .field.is-horizontal(v-if="false")
          label.label.name
          .field-body.has-icon.icon-black
            button.main-btn.bg-transparent.google
              | {{ gettext('Use Google account') }}
              img(src="/webapp/images/icons/google.svg")
            label.label.edit
        .field.is-horizontal(v-if="false")
          .field-body.has-icon.icon-black
            button.main-btn.bg-transparent.facebook
              | {{ gettext('Use Facebook account') }}
              i.mdi.mdi-facebook
            label.label.edit
        .field.is-horizontal
          label.label.name.font {{ gettext('Security') }}
          .field-body
            label.label.edit

        div(v-if="showPassFields" )
          .field.is-horizontal
            label.label.name {{ gettext('Current password') }}*
            .field-body
              input.input(
              v-tooltip="{content: (errors.server.changePassFields || {}).current_password, show: (tooltip.current_password)}"
              name="current_password"
              type="password"
              onfocus="this.removeAttribute('readonly');"
              readonly
              autocomplete="off"
              v-model="changePassFields.current_password"
              :class="{'is-danger': $v.changePassFields.current_password.$error }"
              @blur="validateData('current_password', 'changePassFields')"
              )
              label.label.edit

          .field.is-horizontal
            label.label.name {{ gettext('New password') }}*
            .field-body
              input.input(
              name="new_password"
              type="password"
              onfocus="this.removeAttribute('readonly');"
              readonly
              autocomplete="off"
              v-model="changePassFields.new_password1"
              :class="{'is-danger': $v.changePassFields.new_password1.$error }"
              @input="$v.changePassFields.new_password1.$touch()"
              )
              label.label.edit

          .field.is-horizontal
            label.label.name {{ gettext('Repeat new password') }}*
            .field-body
              input.input(
              name="repeat_new_password"
              type="password"
              onfocus="this.removeAttribute('readonly');"
              readonly
              autocomplete="off"
              v-model="changePassFields.new_password2"
              @input="$v.changePassFields.new_password2.$touch()"
              :class="{'is-danger': $v.changePassFields.new_password2.$error }"
              )
              label.label.edit
        .field.is-horizontal
          .field-body
            button.main-btn.col-white.bg-black.btn-big(
            @click="changePass"
            :disabled="showPassFields && !formPassIsValid"
            )  {{ !this.showPassFields ? gettext('Change password') : gettext('Save new password') }}
            label.label.edit
        div(v-if="showDeleteFields" )
          .field.is-horizontal(v-if="getUser.has_password")
            label.label.name {{ gettext('Your password') }}*
            .field-body
              input.input(
              v-tooltip="{content: (errors.server.deleteAccountFields || {}).current_password, show: (tooltip.current_password)}"
              name="delete_current_password"
              type="password"
              v-model="deleteAccountFields.current_password"
              :class="{'is-danger': $v.deleteAccountFields.current_password.$error }"
              @blur="validateData('current_password', 'deleteAccountFields')"
              )
              label.label.edit
        .field.is-horizontal
          label.label.name
          .field-body
            button.main-btn.col-white.bg-black.btn-big(
            @click="deleteAccount"
            :disabled="showDeleteFields && !formDelIsValid"
            )  {{ gettext('Delete account') }}
            label.label.edit
      image-cropper(
      ref="imageCropper"
      :cropButtonText="gettext('Crop image')"
      :rotateButtonText="gettext('Rotate')"
      :rotate="true"
      :customStrings="{ drag: sender ? gettext('Upload logo') : gettext('Upload image'), change: gettext('Change Photo'), remove: gettext('Remove Photo') }"
      @cropped="loadImage"
      @remove="form.image = ''"
      @update="cropped = !cropped"
      :resize="true"
      v-model="image"
      :class="sender ? 'sender' : 'receiver'"
      )
      .list
        router-link(:to="{name: 'Dashboard', params: {lang: getLanguage}}").field.is-horizontal
          .img-wrap
            img(src="@/assets/images/icons/list-square.png")
          | {{ gettext('Dashboard') }}
        router-link.field.is-horizontal(:to="{name: 'Cabinet', params: {lang: getLanguage}}" v-if="!sender")
          .img-wrap
            img.cabinet-img(src="@/assets/images/icons/cabinet.png")
          | {{ gettext('List of invoices') }}
        router-link.field.is-horizontal(:to="{name: 'Favorites', params: {lang: getLanguage}}")
          .img-wrap
            img(src="@/assets/images/icons/list-square.png")
          | {{ gettext('Wish list') }}
        .field.is-horizontal.linned-bottom
          label.label.name
          .field-body
          label.label.edit
        .field.is-horizontal(@click="exit")
          .img-wrap
            img(src="@/assets/images/icons/log-out.png")
          | {{ gettext('Logout') }}
        .field.is-horizontal.download-personal(@click="downloadPersonalData") {{ gettext('Download your personal information') }}
    v-modal(:show.sync="showDownloadPersonalData" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.text {{ gettext('You can download a copy of your personal information from the Bixter.work at any time. We will prepare a file. Downloading your information is a secure password-protected and that is available only to you. If you want to safe a copy of your data from the Bixter.work, please press "Download" or "Cancel" if you want to wait. You can back here at any time.') }}
        .btn-wrap
          a.main-btn.col-white.bg-red.nav-item.is-tab(:href="userExportUrl" target="_blank" @click="showDownloadPersonalData = false") {{ gettext('Download') }}
          a.main-btn.col-white.bg-black.nav-item.is-tab(@click="showDownloadPersonalData = false") {{ gettext('Cancel') }}

</template>
<script>
import Vue from 'vue'
import { gettext, interpolate } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import Vuelidate from 'vuelidate'
import { required, email, sameAs } from 'vuelidate/lib/validators'
import Datepicker from '@/components/datepicker'
import VTooltip from 'v-tooltip'
import ImageCropper from '@/components/image-cropper'
import VPhoneInput from '@/components/v-phone-input'
import mixin from '@/mixins'
import VModal from '@/components/modal'

const toastr = require('toastr')
const _ = require('lodash')

Vue.use(Vuelidate)
Vue.use(VTooltip, {
  defaultTrigger: 'manual'
})

export default {
  name: 'PartnersProfile',
  components: {
    AjaxDropdown,
    AjaxMultiselect,
    Datepicker,
    ImageCropper,
    VPhoneInput,
    VModal
  },
  mixins: [mixin],
  data () {
    return {
      form: {
        country: this.$store.getters.getUser.country,
        region: this.$store.getters.getUser.region || {},
        email: this.$store.getters.getUser.email,
        company_reg_number: this.$store.getters.getUser.company_reg_number,
        company_name: this.$store.getters.getUser.company_name,
        contact_person: this.$store.getters.getUser.contact_person,
        contact_phone: this.$store.getters.getUser.contact_phone,
        contact_website: this.$store.getters.getUser.contact_website,
        image: this.$store.getters.getUser.companylogo_imgid || '',
        company_about: this.$store.getters.getUser.company_about
      },
      changePassFields: {
        current_password: '',
        new_password1: '',
        new_password2: ''
      },
      userExportUrl: '',
      showDownloadPersonalData: false,
      showDeleteFields: false,
      deleteAccountFields: {
        current_password: ''
      },
      errors: {server: {}},
      tooltip: {},
      image: (this.$store.getters.getUser.avatar_urls || {}).mid || (this.$store.getters.getUser.companylogo_urls || {}).main,
      cropped: false,
      imageLoading: false,
      showPassFields: false
    }
  },
  props: {
    sender: {
      default: false
    }
  },
  validations () {
    return {
      form: {
        email: {
          required,
          email
        },
        region: {
          required
        },
        country: {
          required
        },
        contact_person: {
          required
        },
        contact_phone: {
          required
        },
        company_name: {
          required
        },
        company_reg_number: {
          required
        }
      },
      changePassFields: {
        current_password: {
          required
        },
        new_password1: {
          required
        },
        new_password2: {
          required,
          sameAsPassword: sameAs('new_password1')
        }
      },
      deleteAccountFields: {
        current_password: {
          required
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'logout',
      'receiverProfileUpdate',
      'senderProfileUpdate',
      'uploadImage',
      'changePassword',
      'deactivateAccount',
      'getUserExportUrl'
    ]),
    gettext: gettext,
    interpolate,
    errorProcessor (error, attr, name) {
      _.each(error, (item, key) => {
        if (_.has(this.$data[attr], key)) {
          this.$data[attr][key] = ''
          if (name) {
            this.$set(this.errors.server, name, {})
            this.$set(this.errors.server[name], key, item[0].message)
          } else {
            this.$set(this.errors.server, key, item[0].message)
          }
        }
        this.$v.$touch()
        this.validateData(key, name)
      })
    },
    validateData (item, model = 'form') {
      if (item) {
        if (this.$v[model][item]) {
          this.$v[model][item].$touch()
          if (this.$v[model][item].$error) {
            this.$set(this.tooltip, item, true)
            setTimeout(() => {
              this.$nextTick(() => {
                this.tooltip[item] = false
              })
            }, 3000)
          }
        }
      } else {
        this.$v.$touch()
        let errors = this.$v[model]
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    downloadPersonalData () {
      this.showDownloadPersonalData = true
      this.getUserExportUrl({lang: this.getLanguage}).then(res => {
        this.userExportUrl = res.url
      })
    },
    changePass () {
      this.showPassFields = true
      if (this.showPassFields && this.formPassIsValid) {
        this.changePassword({lang: this.getLanguage, form: this.changePassFields}).then(res => {
          toastr.success(gettext('Request successfully sent'), gettext('Your password has been successfully updated!'))
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors, 'changePassFields', 'changePassFields')
          }
        })
      }
    },
    deleteAccount () {
      this.showDeleteFields = true
      if (this.showDeleteFields && this.formDelIsValid) {
        this.deactivateAccount({lang: this.getLanguage, form: this.deleteAccountFields}).then(res => {
          this.logout({name: 'Login', query: {deletedAccount: true}})
        }).catch(err => {
          if ((err.data || {}).form_errors) {
            this.errorProcessor(err.data.form_errors, 'deleteAccountFields', 'deleteAccountFields')
          }
        })
      }
    },
    toogleInfoshow (item) {
      this.$set(this.tooltip, item, true)
      setTimeout(() => {
        this.$nextTick(() => {
          this.tooltip[item] = false
        })
      }, 3000)
    },
    setErrorsText () {
      this.errors = {
        required: gettext('This field is required'),
        server: {}
      }
    },
    updateProfile () {
      this.$refs.imageCropper.autoCrop()
      let method = this.sender ? 'senderProfileUpdate' : 'receiverProfileUpdate'
      let data = {
        'lang': this.getLanguage,
        'tz': this.$store.getters.getUser.tz,
        'contact_person': this.form.contact_person,
        'contact_phone': this.form.contact_phone,
        'contact_website': this.form.contact_website,
        'companylogo_imgid': this.form.image,
        'company_about': this.form.company_about
      }
      this[method]({lang: this.getLanguage, data: data}).then(() => {
        toastr.success(gettext('Request successfully sent'), gettext('Success!'))
      }).catch((err) => {
        if ((err.data || {}).form_errors) {
          this.errorProcessor(err.data.form_errors, 'form')
        }
        toastr.error(gettext('Profile not updated'), gettext('Error!'))
      })
    },
    imageNormalize (img) {
      if (img) return img.replace(/.*(,)/, '')
    },
    loadImage (value) {
      return new Promise(resolve => {
        if (value) {
          this.imageLoading = true
          this.uploadImage({lang: this.getLanguage, img: this.imageNormalize(value), profile: 'companylogo'}).then(res => {
            this.image = (res.variants.mid || {}).full_url || (res.variants.wide_mid || {}).full_url
            this.form.image = res.imgid
            this.imageLoading = false
            resolve(res)
          })
        }
      })
    },
    exit () {
      this.logout()
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getFinanceAccount',
      'getUser'
    ]),
    allowEdit () {
      if (
        !this.$store.getters.getUser.company_reg_number &&
        !this.$store.getters.getUser.company_name &&
        !this.$store.getters.getUser.region
      ) {
        return true
      }
      return false
    },
    formIsValid: function () {
      return !this.$v.form.$invalid
    },
    formDelIsValid: function () {
      return !this.$v.deleteAccountFields.$invalid
    },
    formPassIsValid: function () {
      return !this.$v.changePassFields.$invalid
    }
  },
  created () {
    this.setErrorsText()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/profile/parts/partners/index.vue